import type { BoardCard } from '$lib/types';

// Due work first, then active work. Blocked work stays visible, not actionable
// as a new start; dates and completion use the same IST day as attendance.
export function myDayOpenCards(cards: BoardCard[], today: string): BoardCard[] {
  const rank = (card: BoardCard) => card.due_date && card.due_date <= today ? 0
    : card.col === 'doing' ? 1 : card.col === 'blocked' ? 2 : 3;
  return cards.filter((card) => card.col !== 'done').sort((a, b) => rank(a) - rank(b)
    || (rank(a) === 0 ? a.due_date!.localeCompare(b.due_date!) : 0)
    || (a.col === 'doing' ? 0 : 1) - (b.col === 'doing' ? 0 : 1)
    || (a.due_date ?? '9999').localeCompare(b.due_date ?? '9999')
    || a.position - b.position || a.id - b.id);
}

export function myDayCompleted(cards: BoardCard[], today: string): BoardCard[] {
  const day = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' });
  return cards.filter((card) => card.col === 'done' && card.done_at
    && Number.isFinite(Date.parse(card.done_at)) && day.format(new Date(card.done_at)) === today);
}

// Selection is an explicit action, not a persisted daily commitment. Unchecked
// cards are never completed, moved, or rescheduled by either punch flow.
export function myDayReviewChanges(cards: BoardCard[], selected: Set<number>, kind: 'in' | 'out') {
  return cards.filter((card) => selected.has(card.id) && (kind === 'in' ? card.col === 'todo' : card.col !== 'done'))
    .map((card) => ({ id: card.id, col: kind === 'in' ? 'doing' as const : 'done' as const }));
}
